<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RHSuug/tc-custom/9781460326060.jpg?1724411686709" alt="This image is the cover for the book Wife by Design, Where Secrets Are Safe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wife by Design, Where Secrets Are Safe
      </h1>
      <p class="bookDescription body article font2">
        <b>In this heartfelt romance series debut, two people devoted to helping others must make room in their lives to pursue their own connection.</b><br/><br/>When life hands you lemons, you make lemonade. That’s what Lynn Duncan believes. A single mother and nurse practitioner, she works at The Lemonade Stand, a unique women’s shelter on the California coast supported by various businesses. These include a physiotherapy service, where landscape designer Grant Bishop takes his disabled brother.<br/><br/>When Grant and Lynn first meet, they’re intensely attracted to each other—but they don’t see a future together. They’re too committed to the people they need to protect. For Lynn that’s three-year-old Kara and the residents at The Lemonade Stand. And Grant will sacrifice <i>anything</i> for his brother. That might have to include a relationship with Lynn..
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tara Taylor Quinn
      </h2>
      
      <p class="authorDescription body article"> Tara Taylor Quinn, is a&#160;<I>USA Today</I>&ndash;bestselling author of one hundred novels, which have been translated into twenty languages and has sold more than seven million copies. Known for her intense emotional fiction, Quinn&rsquo;s novels have received critical acclaim, including the 2008 National Reader&rsquo;s Choice Award, and five RITA Award finalist, and a former president and board director of the Romance Writers of America. She has appeared often on local and national TV, including&#160;<I>CBS Sunday Morning</I>. For additional offers, news, and contests, visit the author at tarataylorquinn.com. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b07a4fba